import { render, staticRenderFns } from "./ProductosPreciosV2Component.vue?vue&type=template&id=dcfac3b2&"
import script from "./ProductosPreciosV2Component.vue?vue&type=script&lang=js&"
export * from "./ProductosPreciosV2Component.vue?vue&type=script&lang=js&"
import style0 from "./ProductosPreciosV2Component.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports